import React from 'react';
import { Empty } from 'antd';
import { PreviewTabProps } from '../types.d';
import { TEST_EMAIL_MODAL_CONSTANTS } from '../constants';
import {
  PreviewBox,
  PreviewTitle,
  PreviewText,
  HtmlPreviewBox,
  CodeBlock,
  DividerStyled,
  StyledTabs,
} from '../styles';

const PreviewTab: React.FC<PreviewTabProps> = ({ previewContent }) => {
  if (!previewContent.subject && !previewContent.html && !previewContent.text) {
    return <Empty description="No preview available. Configure test data in Setup tab." />;
  }

  const previewTabItems = [
    {
      key: 'html-preview',
      label: TEST_EMAIL_MODAL_CONSTANTS.PREVIEW_TABS.HTML_PREVIEW,
      children: previewContent.html ? (
        <HtmlPreviewBox
          dangerouslySetInnerHTML={{
            __html: previewContent.html,
          }}
        />
      ) : (
        <Empty description="No HTML content to preview" />
      ),
    },
    {
      key: 'html-source',
      label: TEST_EMAIL_MODAL_CONSTANTS.PREVIEW_TABS.HTML_SOURCE,
      children: previewContent.html ? (
        <CodeBlock>{previewContent.html}</CodeBlock>
      ) : (
        <Empty description="No HTML source available" />
      ),
    },
    {
      key: 'plain-text',
      label: TEST_EMAIL_MODAL_CONSTANTS.PREVIEW_TABS.PLAIN_TEXT,
      children: previewContent.text ? (
        <PreviewBox>
          <PreviewText>{previewContent.text}</PreviewText>
        </PreviewBox>
      ) : (
        <PreviewBox>
          <PreviewText>{TEST_EMAIL_MODAL_CONSTANTS.HELP_TEXTS.NO_PLAIN_TEXT}</PreviewText>
        </PreviewBox>
      ),
    },
  ];

  return (
    <div>
      {previewContent.subject && (
        <>
          <div>
            <PreviewTitle>{TEST_EMAIL_MODAL_CONSTANTS.HELP_TEXTS.EMAIL_SUBJECT}</PreviewTitle>
            <PreviewBox>
              <PreviewText>{previewContent.subject}</PreviewText>
            </PreviewBox>
          </div>
          <DividerStyled />
        </>
      )}
      <StyledTabs items={previewTabItems} />
    </div>
  );
};

export default PreviewTab;
